import {Component, inject} from '@angular/core';
import {NgClass} from "@angular/common";
import {
  UnassignedTagButtonComponent
} from 'src/app/presentation/main-view/information-center/unassigned-tags/unassigned-tag-button/unassigned-tag-button.component';
import {ViewportService} from 'src/app/infrastructure/viewport.service';
import {BackButtonComponent} from "src/app/presentation/main-view/back-button/back-button.component";
import {CloseButtonComponent} from "src/app/presentation/main-view/close-button/close-button.component";
import {DeviceStore} from 'src/app/domain/devices/device.store';

@Component({
  selector: 'app-unassigned-tags',
  imports: [
    UnassignedTagButtonComponent,
    NgClass,
    BackButtonComponent,
    CloseButtonComponent
],
  templateUrl: './unassigned-tags.component.html',
  styleUrl: './unassigned-tags.component.css'
})
export class UnassignedTagsComponent {

  deviceStore = inject(DeviceStore);
  protected viewportService = inject(ViewportService);
}
